import { render, staticRenderFns } from "./SearchSuggesterBar.vue?vue&type=template&id=550fe6b8"
import script from "./SearchSuggesterBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchSuggesterBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchSuggesterBar.vue?vue&type=style&index=0&id=550fe6b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports